// React
import React from "react";
// React
// CSS
import styles from "./TicketCard.module.css";
// CSS
// Models
import { I_Ticket } from "../../../../Models/interfaces";
// Models
// Components
import { Link } from "react-router-dom";
// Components

type TicketCardProps = {
  data: I_Ticket | any;
};

const TicketCard: React.FunctionComponent<TicketCardProps> = ({
  data: {
    created_at,
    id,
    last_update,
    status: { bgcolor, color, name, open, status },
    subject,
    title,
    updated_at,
  },
}) => {
  return (
    <Link
      to={`/ticketing/tickets/${id}`}
      className={`${styles.ticketCard} flex flex-col items-end py-2 mx-4 pr-1`}
    >
      <div
        className={`${styles.top} w-full flex flex-row-reverse items-center justify-between`}
      >
        <p className=" text-right  w-9/12">{title}</p>
        <p
          style={{
            color,
          }}
          className="text-xs"
        >
          {name}
        </p>
      </div>
      <div
        className={`${styles.mid} mt-2 w-full flex items-center justify-between flex-row-reverse`}
      >
        <p>
          <span>موضوع : </span>
          <span>{subject}</span>
        </p>
        <p>
          <span>شماره تیکت : </span>
          <span>{id}</span>
        </p>
      </div>
      <div
        className={`${styles.bot}  w-full flex flex-row-reverse items-center justify-between mt-3`}
      >
        <p
          style={{
            background:
              Number(open) === 0 ? "rgb(244,67,54)" : "rgb(76,175,80)",
          }}
          className="text-white px-2 py-0.5 text-center text-sm rounded-xl "
        >
          {Number(open) === 0 ? "تیکت بسته" : "تیکت باز"}
        </p>
        <p>
          <span className="text-xs">آخرین بروزرسانی : </span>
          <span className="text-xs">{last_update}</span>
        </p>
      </div>
    </Link>
  );
};

export default TicketCard;
